import { comboboxActions, findNode, getEditorString } from '@udecode/plate';
import { BufferEditor, BufferValue } from '~/editor/BufferEditor/types.plate';
import {
  getTwitterPublicSuggestions,
  TwitterSuggestionResultType,
} from '~/utils/channels/twitter';
import { TwitterPublicSuggestionResponse } from '~/utils/channels/twitter/types';
import { AutocompleteItem } from '../../autocomplete';
import { TwitterMentionInputElement } from '../nodes';

// Parse suggestion response into autocomplete
// items for display in combobox
const parseSuggestions = (
  suggestions: TwitterPublicSuggestionResponse
): AutocompleteItem[] => {
  return suggestions?.users?.map(
    ({ profile_image_url_https, name, screen_name }) => {
      const suggestion = {
        avatar: profile_image_url_https,
        name,
        handle: `${TwitterMentionInputElement.trigger}${screen_name}`,
        url: `https://twitter.com/${screen_name}`,
      };

      return {
        key: `${suggestion.name}-${suggestion.handle}`,
        text: screen_name,
        data: suggestion,
      };
    }
  );
};

/**
 * Callback executed to fetch new Twitter mention suggestions.
 *
 * Updates combobox items on success.
 */
export const getNewSuggestionsOnMentionUpdate = (editor: BufferEditor) => {
  const mentionEntry = findNode<TwitterMentionInputElement, BufferValue>(
    editor,
    { match: (n) => TwitterMentionInputElement.is(n) }
  );

  if (mentionEntry) {
    const searchString = getEditorString(editor, mentionEntry[1]).replace(
      TwitterMentionInputElement.trigger,
      ''
    );

    comboboxActions.items([]);
    getTwitterPublicSuggestions(
      searchString,
      TwitterSuggestionResultType.Mentions
    ).then((searchResults) => {
      if (searchResults) {
        comboboxActions.items(parseSuggestions(searchResults));
      }
    });
  }
};
